import React from 'react';
import './AwardsSlider.css';
import { useTranslation } from 'react-i18next';
import SectionHeading from 'components/SectionHeading';
import SectionSubtitle from 'components/SectionSubtitle';
import underline from './Vector02.png';
import BrandsCircleLine from '../BrandsCircleLine/BrandsCircleLine';
import { awardsItems } from './LogoData';

const logoSizeScale = 1.5;
const awardsLogos = awardsItems.map((item) => ({
  img: item.logo,
  width: `${Math.round(item.size * logoSizeScale)}px`,
}));

const AwardsSlider = () => {
  const { t } = useTranslation();

  return (
    <section className="awards" aria-labelledby="awards-heading">
      <div className="awards-header">
        <div className="awards-titleWrapper">
          <SectionHeading id="awards-heading" size="large" className="awards-title">
            {t('Awards title prefix')}
            <span className="awards-titleHighlightWrap">
              {t('Awards title highlight')}
              <img src={underline} alt="" aria-hidden className="awards-underline" />
            </span>
          </SectionHeading>
        </div>
        <SectionSubtitle size="medium" className="awards-subtitle">{t('Awards subtitle')}</SectionSubtitle>
      </div>

      <div className="awards-container">
        <BrandsCircleLine showHeading={false} logos={awardsLogos} />
      </div>
    </section>
  );
};

export default AwardsSlider;
